import { render, staticRenderFns } from "./PermissionDetailOverlay.vue?vue&type=template&id=3c6fd330"
import script from "./PermissionDetailOverlay.vue?vue&type=script&lang=js"
export * from "./PermissionDetailOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c6fd330')) {
      api.createRecord('3c6fd330', component.options)
    } else {
      api.reload('3c6fd330', component.options)
    }
    module.hot.accept("./PermissionDetailOverlay.vue?vue&type=template&id=3c6fd330", function () {
      api.rerender('3c6fd330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PermissionDetailOverlay.vue"
export default component.exports